/** Minimal shape required by `humanizeRoleName`. */
interface RoleNameInput {
  name: string
  actorType: string
}

/**
 * Map repository-role / org-admin role slugs to their human-readable label.
 * Other actor types pass through unchanged. Shared between the actor-list
 * editor and the bypass-actors row chrome so both render role actors with
 * consistent display names.
 */
export function humanizeRoleName(actor: RoleNameInput): string {
  if (actor.actorType === 'RepositoryRole') {
    switch (actor.name) {
      case 'admin':
        return 'Repository admin'
      case 'maintain':
        return 'Maintain'
      case 'write':
        return 'Write'
      default:
        return actor.name
    }
  } else if (actor.actorType === 'OrganizationAdmin') {
    return actor.name === 'admin' ? 'Organization admin' : actor.name
  }
  return actor.name
}
